export const getDifficultMode = (state) => state.difficult.difficulty;